export default "__VITE_ASSET__DN8r71hA__"